export default [
    {
        path: '/modules',
        name: 'modules',
        component: () =>
            import(
                /* webpackChunkName: "modules" */ '@/views/modules/Index.vue'
            ),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                { text: 'Módulos', to: { name: 'modules' }, disable: true },
            ],
            whitelabel: true,
        },
    },
    {
        path: '/modules/edit/:id',
        name: 'modules/edit',
        child: true,
        component: () =>
            import(
                /* webpackChunkName: "modules" */ '@/views/modules/Edit.vue'
            ),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                { text: 'Módulos', to: { name: 'modules' }, disable: false },
                {
                    text: 'Editar',
                    to: { name: 'modules/edit' },
                    disable: true,
                },
            ],
            whitelabel: true,
        },
        props: true,
    },
]
